import { computed } from 'mobx';
import $auth from 'app/stores/$auth';

/**
 * @typedef {object} LabelCollection
 * @property {number[]} [read]
 * @property {number[]} [update]
 * @property {number[]} [delete]
 */

/**
 * @typedef {object} LabelStore
 * @property {() => LabelCollection} get
 */

/**
 * @param {import('@kentik/ui-shared/rbac/constants').RBACType} type
 * @returns {LabelCollection}
 */
export const getRbacLabelsForType = (type) => {
  const rbacMetadata = $auth.getActiveUserProperty('label_metadata') || {};
  return {
    read: rbacMetadata[`${type}::read`],
    update: rbacMetadata[`${type}::update`],
    delete: rbacMetadata[`${type}::delete`]
  };
};

/**
 * Helper function for determining whether a given item's labels are sufficient to provide RBAC access.
 *
 * Required labels should typically come from a computed value like `requiredDeviceLabels` below.
 *
 * @param {number[] | undefined} requiredLabels
 * @param {number[] | undefined} itemLabels
 * @returns {boolean}
 */
export const hasRequiredLabel = (requiredLabels, itemLabels) =>
  !requiredLabels || !!itemLabels?.some((label) => requiredLabels.includes(label));

/**
 * @type {LabelStore}
 */
export const requiredDeviceLabels = computed(() => getRbacLabelsForType('device'));
